var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "contact_a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "contact_b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#contact_a)",
    d: "M9 37v22h46V37H9zm-1-3h48a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V36a2 2 0 0 1 2-2zm-.16 3.847l1.32-2.694 22.62 11.07a.5.5 0 0 0 .44 0l22.62-11.07 1.32 2.694-22.622 11.07a3.5 3.5 0 0 1-3.076 0L7.84 37.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#contact_b)",
    d: "M61 22V5H34v17a3 3 0 0 1 3 3v1.686l4.923-4.012A3 3 0 0 1 43.818 22H61zm-27 6.79V25h-1a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h29a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H43.818l-6.555 5.341A2 2 0 0 1 34 28.791zM41.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  }))));
};
export default SvgContact;